import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import InputField from './InputField'
import GridMatchInfo from './GridMatchInfo'
import { titlesCalendari } from '../settings/settings'

const DialogPenalita = ({ open, handleClose, triggerFunction, gara }) => {
  const [penalitaCasa, setPenalitaCasa] = useState()
  const [penalitaTrasferta, setPenalitaTrasferta] = useState()

  useEffect(() => {
    setPenalitaCasa(gara?.penalitaCasa)
    setPenalitaTrasferta(gara?.penalitaTrasferta)
  }, [gara])

  const info =
    'Il presente modulo permette di assegnare alle squadre dei punti di penalità, che verranno sottratti dal totale dei punti ottenuti in classifica.'

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(penalitaCasa, penalitaTrasferta)}
      title={titlesCalendari.titleEditPenalita}
      textConfirm='Salva'
      maxWidth='md'
    >
      <GridMatchInfo gara={gara} info={info}>
        <Grid size={{ xs: 12, md: 6 }}>
          <center>
            <InputField
              id='penalitaCasa'
              value={penalitaCasa}
              onChange={setPenalitaCasa}
              autoFocus
              label='Penalità squadra in casa'
              type='number'
            />
          </center>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <center>
            <InputField
              id='penalitaTrasferta'
              value={penalitaTrasferta}
              onChange={setPenalitaTrasferta}
              label='Penalità squadra in trasferta'
              type='number'
            />
          </center>
        </Grid>
      </GridMatchInfo>
    </Dialog>
  )
}

export default DialogPenalita
